import EmptyResult from 'components/others/EmptyResult';
import UsersTableRow from './UsersTableRow';
import type { FetchUsersFn } from './types';
import type { UserType } from '@econtractor/types';

interface UsersTableBodyProps {
    usersList: UserType[];
    setShowSpinner: (value: boolean) => void;
    fetchUsers: FetchUsersFn;
    setShowUserCard: (userId: number | false) => void;
}

const UsersTableBody = ({ usersList, setShowSpinner, fetchUsers, setShowUserCard }: UsersTableBodyProps) => {
    return (
        <tbody>
            {usersList?.length > 0 &&
                usersList.map((user) => (
                    <UsersTableRow
                        key={user.userEmail}
                        setShowSpinner={setShowSpinner}
                        user={user}
                        setShowUserCard={setShowUserCard}
                        fetchUsers={fetchUsers}
                    />
                ))}

            {usersList.length === 0 && (
                <tr>
                    <td colSpan={4}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default UsersTableBody;
